var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4601 14.3148C15.2862 14.0167 15.3869 13.634 15.6851 13.46L18.7596 11.6666L12 7.72346L5.2404 11.6666L8.31492 13.46C8.61308 13.634 8.71379 14.0167 8.53986 14.3148C8.36594 14.613 7.98324 14.7137 7.68508 14.5398L3.68508 12.2064C3.49307 12.0944 3.375 11.8889 3.375 11.6666C3.375 11.4443 3.49307 11.2387 3.68508 11.1267L11.6851 6.46004C11.8797 6.34652 12.1203 6.34652 12.3149 6.46004L20.3149 11.1267C20.5069 11.2387 20.625 11.4443 20.625 11.6666C20.625 11.8889 20.5069 12.0944 20.3149 12.2064L16.3149 14.5398C16.0168 14.7137 15.6341 14.613 15.4601 14.3148Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 19.625C11.6548 19.625 11.375 19.3452 11.375 19L11.375 11C11.375 10.6548 11.6548 10.375 12 10.375C12.3452 10.375 12.625 10.6548 12.625 11L12.625 19C12.625 19.3452 12.3452 19.625 12 19.625Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4419 20.4419C12.1979 20.686 11.8021 20.686 11.5581 20.4419L8.55806 17.4419C8.31398 17.1979 8.31398 16.8021 8.55806 16.5581C8.80214 16.314 9.19786 16.314 9.44194 16.5581L12 19.1161L14.5581 16.5581C14.8021 16.314 15.1979 16.314 15.4419 16.5581C15.686 16.8021 15.686 17.1979 15.4419 17.4419L12.4419 20.4419Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackward);
export default __webpack_public_path__ + "static/media/backward.0e359f3ad900f824e0560f31d46a8e0f.svg";
export { ForwardRef as ReactComponent };